import { render } from "./AdminAds.vue?vue&type=template&id=97089b3e&scoped=true"
import script from "./AdminAds.vue?vue&type=script&lang=js"
export * from "./AdminAds.vue?vue&type=script&lang=js"

import "./AdminAds.vue?vue&type=style&index=0&id=97089b3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97089b3e"]])

export default __exports__